import { Dropdown, MenuItem } from '@heathmont/moon-core-tw';
import DropdownPlaceholder from './FilterDropdown/DropdownPlaceholder';
import useFilterDropdown from './FilterDropdown/useFilterDropdown';

type Props = {
  type: FilterSection;
  rules?: string;
  menuItem?: string;
  theme?: string;
};

const SelectFilterOptions: FC<Props> = ({ type, rules, menuItem, theme }) => {
  const { options } = useFilterDropdown(type, rules, menuItem, theme);

  if (options.length === 0) {
    return <DropdownPlaceholder />;
  }

  return (
    <>
      {options.map((item) => (
        <Dropdown.Option value={item.value} key={item.value}>
          {({ selected, active }) => (
            <MenuItem isActive={active} isSelected={selected}>
              <MenuItem.Checkbox isSelected={selected} />
              <MenuItem.Title>
                <span className="text-moon-14 text-trunks">{item.label}</span>
              </MenuItem.Title>
            </MenuItem>
          )}
        </Dropdown.Option>
      ))}
    </>
  );
};
export default SelectFilterOptions;
